/**
 * 台风服务接口
 * 定义接口
 */
const IEMapService = require('./IEMapService');

/**
 * @description 台风列表
 * @typedef G.service.ITyphoonService~TyphoonList
 * @type {Array}
 * @property {String} id   台风编号
 * @property {String} name  中文名
 * @property {String} nameEn 英文名 
 * @property {Boolean} isActive 是否当前，0=否，1=是
 * @property {String} startTime 开始时间
 * @property {String} endTime   结束时间
 * @property {String} warnLevel    预警级别
 */

/**
 * @description 实时台风
 * @typedef G.service.ITyphoonService~CurrentTyphoonList
 * @type {Array}
 * @property {String} id   台风编号
 * @property {String} name  中文名
 * @property {String} nameEn 英文名 
 * @property {Number} longitude 经度
 * @property {Number} latitude 纬度
 * @property {String} time 时间
 * @property {String} moveDirection   移动方向
 * @property {Number} moveSpeed    移动速度
 * @property {Number} power    
 * @property {Number} pressure       
 * @property {String} strong       
 * @property {Number} speed  
 * @property {Number} radius7     
 * @property {Number} radius10   
 * @property {Number} radius12     
 */

/**
 * @description 台风详情
 * @typedef G.service.ITyphoonService~TyphoonInfo
 * @type {Object}
 * @property {String} id   台风编号
 * @property {String} name  中文名
 * @property {String} nameEn 英文名     
 */

/**
 * @classdesc 台风服务接口
 * @alias G.service.ITyphoonService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.yearUrl {String} 年份服务地址
 * @param opts.infoUrl {String} 详情服务地址
 * @param opts.currentUrl {String} 当前台风地址
 * @param [opts.source] {String} 台风数据来源，默认为温州;浙江水利厅：zjwater
 * @param [opts.crossOrigin] {Boolean} 是否跨域
 */
class ITyphoonService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 获取年度台风
     * @param opts {Object} 年份对象，key值与yearUrl中占位符一致，如{year:"2019"}
     * @returns  {G.service.ITyphoonService~TyphoonList}
     **/
    getTyphoonsByYear(opts) {}


    /**
     * 获取台风详情
     * @param opts {Object} 台风id对象，key值与infoUrl中占位符一致，如{typhoonid:"201804"}
     * @returns {G.service.ITyphoonService~TyphoonInfo}
     */
    getTyphoonInfo(opts) {}


    /**
     * 获取当前台风
     * @returns {G.service.ITyphoonService~CurrentTyphoonList} 
     */
    getCurrent() {}

}
module.exports = ITyphoonService;